import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './css/modules/Logo.module.css';

const Logo = () => {
  const navigate = useNavigate();

  const navigateToHome = () => {
    navigate(process.env.REACT_APP_LOGO_LINK || '/');
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      navigateToHome();
    }
  };

  return (
    <div
      className={styles.logoContainer}
      onClick={navigateToHome}
      onKeyDown={onKeyDown}
      role="link"
      tabIndex={0}
      aria-label="Przejdź do strony głównej"
    >
      <img
        src={process.env.REACT_APP_LOGO_SRC || '/logo.png'}
        alt={process.env.REACT_APP_LOGO_ALT || 'logo'}
        width="130"
        height="130"
        data-logo        // <<< to wyłącza globalne stylowanie img
        draggable="false"
        className={styles.logoImg}
      />
    </div>
  );
};

export default Logo;
